import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, readOnly, generated = false, locked = false, ...props }, ref) => {
  const isReadOnly = readOnly || generated || locked
  const fieldState = locked ? "locked" : generated ? "generated" : isReadOnly ? "readonly" : props.disabled ? "disabled" : "editable"
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border border-input bg-card px-3 py-2.5 text-base shadow-none placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:opacity-45 md:text-sm",
        generated ? "field-generated" : isReadOnly ? "field-readonly" : "field-editable",
        className
      )}
      ref={ref}
      readOnly={isReadOnly}
      aria-readonly={isReadOnly || undefined}
      data-field-state={fieldState}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
